export enum PolicyActionType {
  NEW_OFFER = 'New Offer',
  MODIFICATION_OF_THE_OFFER = 'Modification of the offer',
  NEW_CONTRACT_SIGNED = 'New contract signed',
  CHANGE_IN_COVERAGE = 'Change in Coverage',
  COMPANY_MODIFICATION = 'Company modification',
  EXISTING_POLICY = 'Existing policy',
}
